export const columnsDataComplex = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "TYPE",
    accessor: "biddingType",
  },
  {
    Header: "COUNTRIES",
    accessor: "countries",
  },
  {
    Header: "INSTALLS",
    accessor: "installs",
  },
  {
    Header: "SPEND",
    accessor: "spend",
  },
  {
    Header: "CLICKS",
    accessor: "clicks",
  },
 /*  {
    Header: "CR",
    accessor: "conversion_rate",
  }, */
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "FROM",
    accessor: "fromDate",
  },
  {
    Header: "UNTIL",
    accessor: "untilDate",
  },
];
